import { render } from "./SpriteList.vue?vue&type=template&id=f8060dcc&scoped=true"
import script from "./SpriteList.vue?vue&type=script&lang=js"
export * from "./SpriteList.vue?vue&type=script&lang=js"

import "./SpriteList.vue?vue&type=style&index=0&id=f8060dcc&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8060dcc"]])

export default __exports__